import { IPage } from "../Interfaces";

export class AddUpdatePageCommand {
  public Id: number = 0;
  public Controller: string = "content";
  public Action: string = "getpage";
  public Route: string = "{controller/action}";
  public Language?: string | null = null;
  public Alias: string = "";
  public Title: string = "";
  public HeaderId?: string | null = null;
  public FooterId?: number | null = null;
  public ExcludeSiteMap: boolean = false;
  public SiteId: string = "";
  public ParentPageId?: number | null = null;
  public ParentUrl: string = "";
  public Slug: string = ""
  public IsNewsPage: boolean = false;
  public Url: string = "";

  static MapFromModel(model: IPage): AddUpdatePageCommand | null {
    if (model) {
        const m = new AddUpdatePageCommand();
        m.Id = model.Id;
        m.Url = model.Url;
        m.Controller = model.Controller;
        m.Action = model.Action;
        m.Route = model.Route;
        m.Language = model.Language;
        m.Alias = model.Alias;
        m.HeaderId = (model.HeaderId) ? model.HeaderId : null;
        m.FooterId = (model.FooterId) ? Number(model.FooterId) : null;
        m.Title = model.Title;
        m.ExcludeSiteMap = model.ExcludeSiteMap;
        m.SiteId = model.SiteId;
        m.IsNewsPage = model.IsNewsPage;

        return m;
    } else {
      return null;
    }
}
}
